export default {
  "404": () => import("/app/src/layouts/404.vue").then(m => m.default || m),
  default: () => import("/app/src/layouts/default.vue").then(m => m.default || m)
}